import { render, staticRenderFns } from "./ModalPagosUniversidades.vue?vue&type=template&id=6989b31d"
import script from "./ModalPagosUniversidades.vue?vue&type=script&lang=js"
export * from "./ModalPagosUniversidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports